import React, { useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { CAMPOS_RECURSO } from "./planejamentoRecursosData";
import "./RelatorioPlanejamentoRecursosPrint.css";

const valor = (conteudo) => String(conteudo ?? "").trim() || "-";
const LARGURAS_COLUNAS_PDF = ["14%", "28%", "11%", "17%", "11%", "10%", "9%"];
const ID_QUADRO_IMPRESSAO = "quadro-impressao-planejamento-recursos";

const ESTILOS_PDF_PLANEJAMENTO_RECURSOS = `
  @page { size: A4 landscape; margin: 0; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #071b31; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-recursos { width: 297mm; height: 210mm; margin: 0; padding: 15mm 15mm 6px; overflow: hidden; break-after: page; page-break-after: always; }
  .pagina-pdf-recursos:last-child { break-after: auto; page-break-after: auto; }
  table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-relatorio-recursos td { border: 1px solid #153d64; padding: 6px; text-align: center; }
  .cabecalho-relatorio-recursos td:first-child { width: 28mm; }
  .cabecalho-relatorio-recursos td:last-child { width: 40mm; }
  .cabecalho-relatorio-recursos img { max-width: 26mm; max-height: 15mm; }
  .cabecalho-relatorio-recursos strong, .cabecalho-relatorio-recursos span { display: block; }
  .cabecalho-relatorio-recursos td:nth-child(2) strong { font-size: 16px; color: #0b4b78; }
  .cabecalho-relatorio-recursos span { margin-top: 3px; font-size: 9px; }
  .tabela-relatorio-recursos { font-size: 8px; }
  .tabela-relatorio-recursos th, .tabela-relatorio-recursos td { border: 1px solid #777; padding: 4px 3px; text-align: center; vertical-align: middle; overflow-wrap: anywhere; }
  .tabela-relatorio-recursos th { background: #0b4774; color: #fff; font-size: 8.2px; }
  .tabela-relatorio-recursos .linha-cabecalho-documento > th { border: 0; padding: 0 0 4mm; background: #fff; color: #071b31; }
  .tabela-relatorio-recursos .cabecalho-relatorio-recursos td { border: 1px solid #153d64; padding: 6px; }
  .tabela-relatorio-recursos tbody tr:nth-child(even) { background: #f4f7f9; }
  .tabela-relatorio-recursos tr { break-inside: avoid; page-break-inside: avoid; }
`;

function imprimirPdfPlanejamentoRecursos(elemento, nomeArquivo) {
  if (!elemento) return;
  const tabela = elemento.querySelector(".tabela-relatorio-recursos");
  const cabecalhoTabela = tabela?.querySelector("thead")?.outerHTML || "";
  const definicaoColunas = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "COLGROUP")?.outerHTML || "";
  const corpoTabela = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "TBODY");
  const linhas = Array.from(corpoTabela?.children || []);
  if (!tabela || !cabecalhoTabela || linhas.length === 0) return;

  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();
  const quadroImpressao = document.createElement("iframe");
  quadroImpressao.id = ID_QUADRO_IMPRESSAO;
  quadroImpressao.title = "Impressão do Planejamento de Recursos";
  Object.assign(quadroImpressao.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadroImpressao);

  const janelaImpressao = quadroImpressao.contentWindow;
  const documentoImpressao = quadroImpressao.contentDocument;
  documentoImpressao.open();
  documentoImpressao.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_PDF_PLANEJAMENTO_RECURSOS}</style></head><body></body></html>`);
  documentoImpressao.close();

  function criarPagina() {
    const pagina = documentoImpressao.createElement("section");
    pagina.className = "pagina-pdf-recursos";
    pagina.innerHTML = `<table class="tabela-relatorio-recursos">${definicaoColunas}${cabecalhoTabela}<tbody></tbody></table>`;
    documentoImpressao.body.appendChild(pagina);
    return pagina;
  }

  let paginaAtual = criarPagina();
  const imagensCabecalho = Array.from(paginaAtual.querySelectorAll("img"));
  Promise.all(imagensCabecalho.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(() => {
    linhas.forEach((linha) => {
      let corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-recursos").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
      corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      const linhaInserida = corpoPagina.lastElementChild;
      const limiteInferior = paginaAtual.getBoundingClientRect().bottom - 6;

      if (linhaInserida.getBoundingClientRect().bottom > limiteInferior && corpoPagina.children.length > 1) {
        linhaInserida.remove();
        paginaAtual = criarPagina();
        corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-recursos").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
        corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      }
    });

    janelaImpressao.onafterprint = () => quadroImpressao.remove();
    janelaImpressao.focus();
    janelaImpressao.print();
  });
}

export default function RelatorioPlanejamentoRecursosPrint({ cadastro, onVoltar }) {
  const nomeArquivo = `RQ-1.13-PLANEJAMENTO-DE-RECURSOS-${valor(cadastro?.ano)}`;
  const paginaRef = useRef(null);
  useNomeArquivoPdf(nomeArquivo);

  if (!cadastro) return null;

  return (
    <div className="relatorio-planejamento-recursos-print">
      <div className="acoes-relatorio-recursos">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-recursos" onClick={() => imprimirPdfPlanejamentoRecursos(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>
      <main ref={paginaRef} className="pagina-relatorio-recursos">
        <table className="tabela-relatorio-recursos">
          <colgroup>{LARGURAS_COLUNAS_PDF.map((largura, indice) => <col key={indice} style={{ width: largura }} />)}</colgroup>
          <thead>
            <tr className="linha-cabecalho-documento">
              <th colSpan={CAMPOS_RECURSO.length}>
                <table className="cabecalho-relatorio-recursos">
                  <tbody><tr><td><LogoRelatorio alt="Logo da empresa" /></td><td><strong>PLANEJAMENTO DE RECURSOS — {valor(cadastro.ano)}</strong><span>Sistema de Gestão da Qualidade</span></td><td><strong>RQ 1.13</strong><span>Revisão {valor(cadastro.revisao)}</span><span>Atualizado em {valor(cadastro.atualizadoEmDocumento)}</span></td></tr></tbody>
                </table>
              </th>
            </tr>
            <tr>{CAMPOS_RECURSO.map(([campo, titulo]) => <th key={campo}>{titulo}</th>)}</tr>
          </thead>
          <tbody>{(cadastro.recursos || []).map((recurso, indice) => <tr key={recurso.id || indice}>{CAMPOS_RECURSO.map(([campo]) => <td key={campo}>{valor(recurso[campo])}</td>)}</tr>)}</tbody>
        </table>
      </main>
    </div>
  );
}
